function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 66.83,
  r: 13.5
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 115.5,
  cy: 135.5,
  r: 13.5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 134.5,
  cy: 17.5,
  r: 13.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M120.17 16.65a128.24 128.24 0 00-93.53 39.82M109.2 123.48c-5.54-12.74-11.51-33.85-5.36-58.31a89 89 0 0119.94-37.39M24.32 78.73a128.65 128.65 0 0076.68 54.1"
});

var SvgConnectivity = function SvgConnectivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 152 153",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgConnectivity;